import styled from 'styled-components';
import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import RecommendedArticlesList from '../../knowledge-base/RecommendedArticlesList';
import CategoriesList from '../../knowledge-base/CategoriesList';
import { TRENDING, NONE } from '../../knowledge-base/constants/knowledgeBaseRecommendationTypes';
import { useKBLibrary } from '../../knowledge-base/context/KBLibraryProvider';
import { CATEGORY_VIEW, KNOWLEDGE_BASE_ARTICLE } from '../../visitor-widget/constants/views';
import CategoryArticlesPreview from './CategoryArticlesPreview';
import KBArticlePreview from '../../knowledge-base/KBArticle';
import useKBLibraryData from '../hooks/useKBLibraryData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const KBLibraryWrapper = styled.div.withConfig({
  displayName: "KBLibraryPreview__KBLibraryWrapper",
  componentId: "cjels1-0"
})(["height:100%;overflow-y:scroll;"]);
const LoadingWrapper = styled.div.withConfig({
  displayName: "KBLibraryPreview__LoadingWrapper",
  componentId: "cjels1-1"
})(["display:flex;justify-content:center;align-items:center;height:80%;"]);
const KBLibraryContent = ({
  recommendedArticles,
  categories,
  coloring,
  kbRecommendationType,
  updateView,
  currentView,
  knowledgeBaseId,
  knowledgeBaseUrl,
  knowledgeBaseEnabled,
  isUngatedForKBImprovement
}) => {
  const {
    setSelectedArticle,
    setSelectedCategory,
    selectedArticle,
    selectedCategory,
    setOriginView
  } = useKBLibrary();
  const handleArticleClick = article => {
    setSelectedArticle({
      hubSpotContentId: `${article.id}`,
      deepLink: article.url,
      hubSpotContentTextFragment: ''
    });
    setOriginView(currentView);
    updateView(KNOWLEDGE_BASE_ARTICLE);
  };
  const handleCategoryClick = categoryId => {
    const category = categories.find(cat => cat.categoryId === categoryId);
    if (category) {
      setSelectedCategory(category);
    }
    setOriginView(currentView);
    updateView(CATEGORY_VIEW);
  };
  if (currentView === KNOWLEDGE_BASE_ARTICLE && selectedArticle) {
    return /*#__PURE__*/_jsx(KBArticlePreview, {
      kbArticle: selectedArticle
    });
  }
  if (currentView === CATEGORY_VIEW && selectedCategory) {
    return /*#__PURE__*/_jsx(CategoryArticlesPreview, {
      knowledgeBaseId: knowledgeBaseId,
      knowledgeBaseUrl: knowledgeBaseUrl,
      coloring: coloring,
      selectedCategory: selectedCategory,
      onArticleClick: handleArticleClick
    });
  }
  const disableBrowsing = !knowledgeBaseId || !knowledgeBaseEnabled || !isUngatedForKBImprovement;
  return /*#__PURE__*/_jsxs(KBLibraryWrapper, {
    children: [recommendedArticles.length > 0 && kbRecommendationType !== NONE && /*#__PURE__*/_jsx(RecommendedArticlesList, {
      articles: recommendedArticles.slice(0, 3),
      coloring: coloring,
      onArticleClick: handleArticleClick,
      hideSubtitle: true,
      kbRecommendationType: kbRecommendationType,
      disabled: disableBrowsing
    }), categories.length > 0 && /*#__PURE__*/_jsx(CategoriesList, {
      categories: categories,
      coloring: coloring,
      onCategoryClick: handleCategoryClick,
      disabled: disableBrowsing
    })]
  });
};
KBLibraryContent.displayName = 'KBLibraryContent';
const KBLibraryPreview = ({
  knowledgeBaseId,
  knowledgeBaseUrl = '',
  coloring,
  kbRecommendationType = TRENDING,
  knowledgeBaseEnabled = false,
  isKnowledgeBaseV3 = false,
  isUngatedForKBImprovement = false,
  updateView,
  currentView
}) => {
  const {
    recommendedArticles,
    categories,
    isLoading
  } = useKBLibraryData({
    knowledgeBaseId,
    knowledgeBaseUrl,
    kbRecommendationType,
    knowledgeBaseEnabled,
    isKnowledgeBaseV3,
    isUngatedForKBImprovement
  });
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingWrapper, {
      children: /*#__PURE__*/_jsx(VizExLoadingSpinner, {})
    });
  }
  if (!knowledgeBaseEnabled || !knowledgeBaseId) {
    kbRecommendationType = TRENDING;
  }
  if (knowledgeBaseEnabled && knowledgeBaseId && !isKnowledgeBaseV3) {
    return null;
  }
  return /*#__PURE__*/_jsx(KBLibraryContent, {
    recommendedArticles: recommendedArticles,
    categories: categories,
    coloring: coloring,
    kbRecommendationType: kbRecommendationType,
    updateView: updateView,
    currentView: currentView,
    knowledgeBaseId: knowledgeBaseId,
    knowledgeBaseUrl: knowledgeBaseUrl,
    knowledgeBaseEnabled: knowledgeBaseEnabled,
    isUngatedForKBImprovement: isUngatedForKBImprovement
  });
};
KBLibraryPreview.displayName = 'KBLibraryPreview';
export default KBLibraryPreview;